// Labels for lessons on the attendance screens: "10:00–12:00", "304 · Objekti P2".

// Minutes since midnight for "10:00", "9:00" or "10:00:00"; null when there is no time.
export const toMinutes = (time) => {
  const match = /^(\d{1,2}):(\d{2})/.exec(time || '');
  return match ? Number(match[1]) * 60 + Number(match[2]) : null;
};

export const formatMinutes = (minutes) =>
  `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;

export const formatSlotTime = (time) => {
  const minutes = toMinutes(time);
  return minutes === null ? (time || '') : formatMinutes(minutes);
};

export const timeRange = (start, end) =>
  [formatSlotTime(start), formatSlotTime(end)].filter(Boolean).join('–');

// Rooms are known by number and building ("304 · Objekti P2"); the room name is usually just
// "Sallë Mësimore". The "Online" rooms have number 0 and go by their name. Null without a room.
export const roomLabel = ({ roomCode, building, branchName, room, roomName }) =>
  roomCode && roomCode !== '0'
    ? [roomCode, building || branchName].filter(Boolean).join(' · ')
    : room || roomName || null;

export const formatDay = (date) =>
  date ? new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '.') : '';
